var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalculator = function SvgCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109 109"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 106,
    rx: 4,
    ry: 4,
    fill: "#dcdcdc",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.8,
    y: 54,
    width: 28,
    height: 3,
    rx: 1.5,
    ry: 1.5,
    fill: "#9e9e9e",
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.8,
    y: 66.5,
    width: 28,
    height: 3,
    rx: 1.5,
    ry: 1.5,
    fill: "#9e9e9e",
    strokeWidth: 0
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.8,
    y: 79,
    width: 28,
    height: 3,
    rx: 1.5,
    ry: 1.5,
    fill: "#9e9e9e",
    strokeWidth: 0
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 18,
    width: 70,
    height: 91,
    rx: 1,
    ry: 1,
    fill: "#5700d1",
    strokeWidth: 0
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 26.8,
    width: 50,
    height: 12,
    fill: "#fff",
    strokeWidth: 0
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 32.3,
    width: 7,
    height: 1,
    rx: 0.5,
    ry: 0.5,
    fill: "#8051ff",
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 55.5,
    r: 4.5,
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 55.5,
    r: 4.5,
    fill: "#8051ff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 55.5,
    r: 4.5,
    fill: "#fff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 72.5,
    r: 4.5,
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 72.5,
    r: 4.5,
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 72.5,
    r: 4.5,
    fill: "#fff",
    strokeWidth: 0
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 89.5,
    r: 4.5,
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 89.5,
    r: 4.5,
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 89.5,
    r: 4.5,
    fill: "#fff",
    strokeWidth: 0
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.8,18.1c-6.9,0-12.5,5.6-12.5,12.5s5.6,12.5,12.5,12.5,12.5-5.6,12.5-12.5-5.6-12.5-12.5-12.5ZM20.8,36.6c-3.3,0-6-2.7-6-6s2.7-6,6-6,6,2.7,6,6-2.7,6-6,6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8,18.1c0,0-.2,0-.3,0v6.5c0,0,.2,0,.3,0,3.3,0,6,2.7,6,6s-2.7,6-6,6-.2,0-.3,0v6.5c0,0,.2,0,.3,0,6.9,0,12.5-5.6,12.5-12.5s-5.6-12.5-12.5-12.5Z",
    fill: "#8051ff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4,34.4c-1.1,1.3-2.7,2.1-4.6,2.1-3.1,0-5.7-2.4-6-5.4h-6.5c.3,6.6,5.8,11.9,12.5,11.9s6.9-1.6,9.2-4l-4.6-4.6Z",
    fill: "#5700d1",
    strokeWidth: 0
  }))));
};
export default SvgCalculator;